import React from 'react';

export default function ExperimentInfoRow(props) {
  return (
    <div
      id={props.id ?? 'experimentinforow-wrapper'}
      data-testid={props.id ?? 'experimentinforow-wrapper'}
      className="row"
      style={{ margin: '10px 30px' }}
    >
      <div
        id={`experimentinforow-label-${props.text}`}
        data-testid={`experimentinforow-label-${props.text}`}
        className="col-md-6"
        style={{
          fontWeight: 400,
          fontSize: '0.8125rem',
          padding: 5,
        }}
      >
        {props.text}
      </div>
      <div
        id={props.id ? `${props.id}-content` : 'experimentinforow-content'}
        data-testid={props.id ? `${props.id}-content` : 'experimentinforow-content'}
        className={props.className}
        style={{ padding: 0 }}
      >
        {props.children}
      </div>
    </div>
  );
}
